import React from 'react';
import _ from 'lodash';

import searchIcon from 'assets/icons/search.svg';

import './styles.css';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
}

class SearchFilter extends React.Component<SearchFilterProps> {
  state = {
    searchValue: this.props.value
  };

  debouncedSearch = _.debounce(() => {
    this.props.onChange(this.state.searchValue);
  }, 1000);

  componentDidUpdate(prevProps: any, prevState: any) {
    const propsHaveChanged = prevProps.value !== this.props.value;
    const afterClearFiltersIsPressed =
      this.props.value == '' && this.state.searchValue !== '';

    if (propsHaveChanged && afterClearFiltersIsPressed) {
      this.setState({
        ...prevState,
        searchValue: this.props.value
      });
    }
  }

  onSearchChange = value => {
    this.setState({searchValue: value}, this.debouncedSearch);
  };

  render() {
    return (
      <div className="SearchFilter">
        <div
          className="SearchFilter__wrapper colab-small-border-radius"
          style={{backgroundImage: 'url(' + searchIcon + ')'}}>
          <input
            type="text"
            placeholder="Search"
            value={this.state.searchValue}
            onChange={event => this.onSearchChange(event.target.value)}
          />
        </div>
      </div>
    );
  }
}

export default SearchFilter;
